import Login from "../components/Login/Login";
import background from "./background.jpg";

export default function LoginPage() {
  return (
    <div style={{ backgroundImage: `url(${background})` }}>
      <Login />;
    </div>
  );
}
